import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import httpRequest from "../../utils/Http";
import { toast } from "react-toastify";
import MainBody from "../../component/MainBody";
import { LABEL_JOB } from "../../constant/label_constant";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import { UploadFileToS3 } from "../../utils/S3File";
import FileDownloadDropdown from "../../component/FileDownloadDropdown";

const PartOrderRequest = () => {
  const navigate = useNavigate();
  const { bid, spare_id } = useParams();
  const [isSubmit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({ previousPart: [] });
  const [formErrors, setFormErrors] = useState({});
  const [partTypelist, setPartTypelist] = useState([]);
  const [partNameList, setPartNameList] = useState([]);
  const [partWarrantyList, setpartWarrantyList] = useState([]);
  const [quantitylist, setQuantityList] = useState([]);
  const [files, setFiles] = useState([]);
  const [partImagesList, setPartImagesList] = useState([]);
  const [isRequestPart, setIsRequestPart] = useState(true);
  const [previousPart, setPreviousPart] = useState([]);
  const [consumptionList, setConsumptionList] = useState([]);

  // useEffect(() => {
  //   console.log(formData)

  // }, [formData])

  const onDrop = (acceptedFiles) => {
    setFiles((prevFiles) =>
      prevFiles.concat(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      ),
    );
    setFormErrors({ ...formErrors, documentTypeId: "" });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*, application/*, text/*, video/*",
  });

  const validateForm = (value) => {
    const errors = {};
    console.log(value);

    if (!value.part_type) {
      errors.part_type = "Part Type is mandatory";
    }

    if (!value.part_id) {
      errors.part_id = "Part Name is mandatory";
    }

    if (!value.part_warranty) {
      errors.part_warranty = "Part Warranty is mandatory";
    }

    if (!value.quantity) {
      errors.quantity = "Quantity is mandatory";
    }

    if (!value.remarks) {
      errors.remarks = "Problem Description is mandatory";
    }

    if (!value.spare_id) {
      if (files.length === 0) {
        errors.files = "Select at least one file";
      }
    }

    if (previousPart.length > 0) {
      if (!value.previousPart || value.previousPart.length === 0) {
        errors.previousPart = "Consumption is mandatory for previous part";
      } else {
        for (const item of value.previousPart) {
          if (!item.consumption_id) {
            errors.previousPart = "Consumption is mandatory for previous part";
            break;
          }
        }
      }
    }

    return errors;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formData));
    setSubmit(true);
  };

  useEffect(() => {
    const submitData = async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const formDataToSubmit = { ...formData };
        if (files.length > 0) {
          window["showloadingmodel"]();

          const uploadPromises = files.map((file) =>
            UploadFileToS3("docFile", file),
          );
          const fileUrls = await Promise.all(uploadPromises);

          const dataToSave = files.map((file, index) => ({
            docFileurl: fileUrls[index],
            docName: file.name,
          }));

          formDataToSubmit.documentFile = JSON.stringify(dataToSave);

          setFormData(formDataToSubmit);
          window["distroyloadingmodel"]();
        }

        if (formDataToSubmit?.previousPart) {
          formDataToSubmit.previousPart = JSON.stringify(
            formDataToSubmit.previousPart,
          );
        }

        const res = await httpRequest(
          "processrequestpartorder",
          formDataToSubmit,
          "POST",
          "multipart/form-data",
        );

        if (res.status) {
          setFiles([]);
          toast.success(res.message);
          navigate("/pendingbooking");
        } else {
          toast.error(res.message);
        }
        setSubmit(false);
      }
    };
    submitData();
  }, [isSubmit, formErrors]);

  useEffect(() => {
    (async () => {
      if (bid) {
        try {
          const id = atob(bid);
          const data = await httpRequest(
            "getbookingdetails?ishistory=0&id=" + id,
            {},
            "GET",
          );

          if (data.status === true) {
            if (
              !data.bookingData.sc_closed_date &&
              !data.bookingData.closed_date
            ) {
              if (data.bookingData.calltype_group.is_part_order === true) {
                const sf_purchase_date = data.userApplianceDetails
                  .sf_purchase_date
                  ? new Date(data.userApplianceDetails.sf_purchase_date)
                  : "";

                let part_warranty = 1;

                data.bookingCharges.map((item) => {
                  // console.log(item.call_type.allowed_warranty_status)
                  let parse = JSON.parse(
                    item.call_type.allowed_warranty_status,
                  );
                  //  console.log(parse)
                  if (Array.isArray(parse)) {
                    setpartWarrantyList(parse);
                  } else {
                    parse = JSON.parse(parse);
                    setpartWarrantyList(parse);
                  }

                  for (const item1 of parse) {
                    //console.log(item1)
                    if (Number(item1.value) === 2) {
                      part_warranty = 2;
                    }
                  }
                });

                setFormData({
                  ...formData,
                  booking_id: data.bookingData.booking_id,
                  partner_id: data.bookingData.partner_id,
                  calltype: {
                    label: data.bookingData.calltype_group.type,
                    value: data.bookingData.calltype_group.id,
                  },
                  appliance_id: data.bookingData.appliance_id,
                  model_number: data.userApplianceDetails.model_number,
                  model_id: data.userApplianceDetails.model_id,
                  sf_serial_number: data.userApplianceDetails.sf_serial_number,
                  sf_purchase_date: sf_purchase_date,
                  sf_invoice_id: data.bookingData.sf_invoice_id,
                  bid: data.bookingData.id,
                  sf_serial_number_file:
                    data.userApplianceDetails.sf_serial_number_file,
                  sf_invoice_file: data.userApplianceDetails.invoice_file,
                  part_warranty: part_warranty,
                });

                if (spare_id) {
                  (async () => {
                    try {
                      const spareId = atob(spare_id);
                      const spare_response = await httpRequest(
                        `getsparedetailslist?id=${spareId}`,
                        {},
                        "GET",
                      );
                      if (spare_response.status && spare_response.data) {
                        const data = spare_response.data["rows"][0];
                        // Set initial formData first
                        const initialFormData = {
                          spare_id: data.id,
                          part_type: data.requested_part.part_type,
                          part_id: data.requested_part_id,
                          part_warranty: data.warranty_status,
                          quantity: data.requested_quantity,
                          remarks: data.problem_description,
                        };
                        setFormData((prevData) => ({
                          ...prevData,
                          ...initialFormData,
                        }));

                        // Fetch part name list
                        const partNameListResponse = await httpRequest(
                          `getbompartnamelist?partner_id=${data.booking_detail.partner_id}&appliance_id=${data.booking_detail.appliance_id}&model_id=${data.requested_model_id}&part_type=${encodeURIComponent(data.requested_part.part_type)}`,
                          {},
                          "GET",
                        );
                        if (
                          partNameListResponse.status === true &&
                          partNameListResponse.data
                        ) {
                          setPartNameList(partNameListResponse.data);
                        }

                        // // Fetch quantity list
                        const quantityListResponse = await httpRequest(
                          `getbommaxqauntity?model_id=${data.requested_model_id}&part_id=${data.requested_part_id}`,
                          {},
                          "GET",
                        );
                        if (
                          quantityListResponse.status === true &&
                          quantityListResponse.data
                        ) {
                          setQuantityList(quantityListResponse.data);
                        }
                      }
                    } catch (error) {
                      console.log(error);
                      // toast.error(
                      //   `Invalid Url`
                      // );
                      // navigate('/pendingbooking')
                    }
                  })();
                }
              } else {
                toast.error(
                  `We are not allowing to request part for the attatched calltype on this ${LABEL_JOB}`,
                );
                navigate("/pendingbooking");
              }
            } else {
              toast.error(
                `${LABEL_JOB} already closed. You can not allow to update booking`,
              );
              navigate("/pendingbooking");
            }
          } else {
            console.log(".....");
            toast.error(`${LABEL_JOB} Not Found`);
            navigate("/404");
          }
        } catch (error) {
          console.log(".....");
          navigate("/404");
        }
      }
    })();
  }, [bid, spare_id]);

  useEffect(() => {
    (async () => {
      if (formData.appliance_id && formData.partner_id && formData.model_id) {
        const partTypelist = await httpRequest(
          `getbomparttypelist?partner_id=${formData.partner_id}&appliance_id=${formData.appliance_id}&model_id=${formData.model_id}`,
          {},
          "GET",
        );

        if (partTypelist.status === true && partTypelist.data) {
          setPartTypelist(partTypelist.data);
        }
      }
    })();
  }, [formData.partner_id, formData.model_id, formData.appliance_id]);

  useEffect(() => {
    (async () => {
      if (
        formData.appliance_id &&
        formData.partner_id &&
        formData.model_id &&
        formData.part_type
      ) {
        const { part_name, quantity, part_warranty, ...rest } = formData;
        setFormData(rest);
        const partTypelist = await httpRequest(
          `getbompartnamelist?partner_id=${formData.partner_id}&appliance_id=${formData.appliance_id}&model_id=${formData.model_id}&part_type=${encodeURIComponent(formData.part_type)}`,
          {},
          "GET",
        );

        if (partTypelist.status === true && partTypelist.data) {
          setPartNameList(partTypelist.data);
        }
      }
    })();
  }, [
    formData.partner_id,
    formData.model_id,
    formData.appliance_id,
    formData.part_type,
  ]);

  useEffect(() => {
    (async () => {
      if (formData.model_id && formData.part_id) {
        const partTypelist = await httpRequest(
          `getbommaxqauntity?model_id=${formData.model_id}&part_id=${formData.part_id}`,
          {},
          "GET",
        );

        if (partTypelist.status === true && partTypelist.data) {
          setQuantityList(partTypelist.data);
        }
      }
    })();
  }, [formData.model_id, formData.part_id]);

  useEffect(() => {
    setPartImagesList([]);
    setPreviousPart([]);
    if (formData?.part_id) {
      (async () => {
        const partImageList = await httpRequest(
          `getpartfiles?part_id=${formData.part_id}`,
          {},
          "GET",
        );

        if (partImageList.status === true && partImageList.data) {
          setPartImagesList(partImageList.data);
        }

        if (spare_id === undefined) {
          const consumptionData = await httpRequest(
            `getconsumtionlist`,
            {},
            "GET",
          );
          if (consumptionData.status) {
            setConsumptionList(consumptionData.data);
          }
          const data = await httpRequest(
            `getisparttobeordered?part_id=${formData.part_id}&bid=${formData.bid}`,
            {},
            "GET",
          );

          if (data.status === true) {
            setIsRequestPart(data.isRequest);
            if (!data.isRequest) {
              toast.error(data.message);
            } else if (data?.data && data.data.length > 0) {
              setPreviousPart(data.data);
            }
          } else {
            setIsRequestPart(false);
            toast.error(data.message);
          }
        }
      })();
    }
  }, [formData?.part_id, spare_id]);

  const selectedPart = partNameList.find(
    (option) => option.value === formData.part_id,
  );
  const selectedWarranty = partWarrantyList.find(
    (option) => option.value === formData.part_warranty,
  );
  const selectedQuantity = quantitylist.find(
    (option) => option.value === formData.quantity,
  );

  const renderError = (field) =>
    formErrors[field] && (
      <span className="part-request__error">{formErrors[field]}</span>
    );

  return (
    <MainBody
      breadcrumbTitle="Request New Part"
      breadcrumbSubTitle={formData.booking_id ? formData.booking_id : ""}
      navButton=""
      title=""
      component={
        <section className="part-request">
          <div className="part-request__shell">
            <div className="part-request__intro">
              <div>
                <span className="part-request__eyebrow">
                  <i className="fas fa-wrench" aria-hidden="true" /> Parts desk
                </span>
                <h1>Request a replacement part</h1>
                <p>
                  Tell us what failed and attach clear evidence so the warehouse
                  can move quickly.
                </p>
              </div>
              <div className="part-request__status">
                <span className="part-request__status-dot" /> New request
              </div>
            </div>

            <div className="part-request__layout">
              <aside className="part-request__context">
                <div className="part-request__context-heading">
                  <span className="part-request__icon">
                    <i className="fas fa-clipboard-list" aria-hidden="true" />
                  </span>
                  <div>
                    <span>Service context</span>
                    <strong>{formData.booking_id || "Loading booking"}</strong>
                  </div>
                </div>
                <dl className="part-request__summary">
                  <div>
                    <dt>Job type</dt>
                    <dd>{formData.calltype?.label || "-"}</dd>
                  </div>
                  <div>
                    <dt>Appliance model</dt>
                    <dd>{formData.model_number || "-"}</dd>
                  </div>
                  <div>
                    <dt>Serial number</dt>
                    <dd>{formData.sf_serial_number || "-"}</dd>
                  </div>
                  <div>
                    <dt>Purchase date</dt>
                    <dd>
                      {formData.sf_purchase_date
                        ? new Date(
                            formData.sf_purchase_date,
                          ).toLocaleDateString()
                        : "-"}
                    </dd>
                  </div>
                </dl>
                <div className="part-request__help">
                  <i className="fas fa-circle-info" aria-hidden="true" />
                  <span>
                    Use the part reference shown in the service job. One request
                    can include multiple evidence files.
                  </span>
                </div>
              </aside>

              <form
                id="addbasicdetails"
                className="part-request__form"
                onSubmit={onSubmitHandler}
              >
                <section className="part-request__section">
                  <div className="part-request__section-heading">
                    <div>
                      <span className="part-request__step">01</span>
                      <div>
                        <h2>Part details</h2>
                        <p>Choose the part you need from the approved list.</p>
                      </div>
                    </div>
                  </div>
                  <div className="part-request__fields">
                    <div className="part-request__field">
                      <label>
                        Part type <b>*</b>
                        {renderError("part_type")}
                      </label>
                      <Select
                        className="select2-purple"
                        value={
                          partTypelist.find(
                            (option) => option.value === formData.part_type,
                          ) || null
                        }
                        name="part_type"
                        placeholder="Select part type"
                        options={partTypelist}
                        onChange={(val) =>
                          setFormData({
                            ...formData,
                            part_type: val.value,
                            part_id: null,
                          })
                        }
                      />
                    </div>
                    <div className="part-request__field">
                      <label>
                        Part name <b>*</b>
                        {partImagesList.length > 0 && (
                          <FileDownloadDropdown
                            files={partImagesList}
                            setReload={() => {}}
                            isDelete={false}
                          />
                        )}
                        {renderError("part_id")}
                      </label>
                      <Select
                        className="select2-purple"
                        value={selectedPart || null}
                        name="part_id"
                        placeholder="Select part name"
                        options={partNameList}
                        onChange={(val) =>
                          setFormData({ ...formData, part_id: val.value })
                        }
                      />
                    </div>
                    <div className="part-request__field">
                      <label>
                        Warranty status <b>*</b>
                        {renderError("part_warranty")}
                      </label>
                      <Select
                        className="select2-purple"
                        value={selectedWarranty || null}
                        name="part_warranty"
                        placeholder="Select warranty status"
                        options={
                          Array.isArray(partWarrantyList)
                            ? partWarrantyList.map((item) => ({
                                label: item.label,
                                value: item.value,
                              }))
                            : []
                        }
                        onChange={(val) =>
                          setFormData({ ...formData, part_warranty: val.value })
                        }
                      />
                    </div>
                    <div className="part-request__field">
                      <label>
                        Quantity <b>*</b>
                        {renderError("quantity")}
                      </label>
                      <Select
                        className="select2-purple"
                        value={selectedQuantity || null}
                        name="quantity"
                        placeholder="Select quantity"
                        options={quantitylist}
                        onChange={(val) =>
                          setFormData({ ...formData, quantity: val.value })
                        }
                      />
                    </div>
                    <div className="part-request__field part-request__field--description">
                      <label>
                        Problem description <b>*</b>
                        {renderError("remarks")}
                      </label>
                      <input
                        type="text"
                        placeholder="Describe the fault or replacement reason"
                        value={formData.remarks || ""}
                        className="part-request__input"
                        onChange={(e) =>
                          setFormData({ ...formData, remarks: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </section>

                <section className="part-request__section">
                  <div className="part-request__section-heading">
                    <div>
                      <span className="part-request__step">02</span>
                      <div>
                        <h2>Evidence</h2>
                        <p>Add a picture or video of the defective part.</p>
                      </div>
                    </div>
                    <span className="part-request__required">Required</span>
                  </div>
                  <div {...getRootProps()} className="part-request__dropzone">
                    <input {...getInputProps()} />
                    <span className="part-request__upload-icon">
                      <i className="fas fa-cloud-arrow-up" aria-hidden="true" />
                    </span>
                    <div>
                      <strong>Drop files here or browse</strong>
                      <p>
                        Images, videos, documents and other supporting files
                      </p>
                    </div>
                    <span className="part-request__browse">Browse files</span>
                  </div>
                  {renderError("files")}
                  {files.length > 0 && (
                    <div className="part-request__files">
                      {files.map((file) => (
                        <div className="part-request__file" key={file.name}>
                          <i className="fas fa-file-lines" aria-hidden="true" />
                          <span>{file.name}</span>
                          <small>{Math.round(file.size / 1024)} KB</small>
                        </div>
                      ))}
                    </div>
                  )}
                </section>

                {previousPart?.length > 0 && (
                  <section className="part-request__section part-request__section--consumption">
                    <div className="part-request__section-heading">
                      <div>
                        <span className="part-request__step">03</span>
                        <div>
                          <h2>Previous requests</h2>
                          <p>Update consumption before sending this request.</p>
                        </div>
                      </div>
                    </div>
                    <div className="part-request__notice">
                      <i
                        className="fas fa-circle-exclamation"
                        aria-hidden="true"
                      />{" "}
                      This part was requested earlier. Select how the previous
                      part was consumed.
                    </div>
                    <div className="part-request__table-wrap">
                      <table className="part-request__table">
                        <thead>
                          <tr>
                            <th>Part name</th>
                            <th>Status</th>
                            <th>Acknowledged</th>
                            <th>
                              Consumption <b>*</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {previousPart.map((item) => (
                            <tr key={item.id}>
                              <td>
                                <strong>
                                  {item?.requested_part?.part_name || "N/A"}
                                </strong>
                              </td>
                              <td>
                                <span className="part-request__pill">
                                  {item.status}
                                </span>
                              </td>
                              <td>
                                {item.forward_part_ack_date
                                  ? new Date(
                                      item.forward_part_ack_date,
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </td>
                              <td>
                                <Select
                                  className="select2-purple"
                                  name="consumption_id"
                                  placeholder="Select consumption"
                                  options={consumptionList}
                                  onChange={(val) =>
                                    setFormData((prev) => {
                                      const updatedPart = [
                                        ...(prev.previousPart || []),
                                      ];
                                      const index = updatedPart.findIndex(
                                        (part) => part.id === item.id,
                                      );
                                      if (index !== -1)
                                        updatedPart[index] = {
                                          ...updatedPart[index],
                                          consumption_id: val.value,
                                          is_consumed: val.is_consumed,
                                        };
                                      else
                                        updatedPart.push({
                                          id: item.id,
                                          consumption_id: val.value,
                                          is_consumed: val.is_consumed,
                                        });
                                      return {
                                        ...prev,
                                        previousPart: updatedPart,
                                      };
                                    })
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {renderError("previousPart")}
                  </section>
                )}

                {isRequestPart ? (
                  <div className="part-request__actions">
                    <button
                      type="button"
                      className="btn btn-light part-request__cancel"
                      onClick={() => navigate("/pendingbooking")}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      id="submit"
                      className="btn btn-primary part-request__submit"
                    >
                      <i className="fas fa-paper-plane" aria-hidden="true" />{" "}
                      Submit request
                    </button>
                  </div>
                ) : (
                  <div className="part-request__blocked">
                    <i className="fas fa-lock" aria-hidden="true" />
                    <span>
                      This part cannot be requested for the current job.
                    </span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </section>
      }
    />
  );
};

export default PartOrderRequest;
